import { DraggedSingleData } from "../../../../components/ui/DragToolsUI";
import { HudActions } from "../../../../components/ui/hud/HUDUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../misc/constants";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import GeneralNeutralStateMain, { GeneralNeutralStatePart7Config, GeneralNeutralStateMainConfig } from "../GeneralNeutralStateMain";
import GeneralNeutralStatePart1 from "./GeneralNeutralStatePart1";

export default class GeneralNeutralStatePart7 extends BaseScenarioPart<DaarcBaseScenario> {
	private alreadyDone = false;
	private get config(): GeneralNeutralStatePart7Config {
		return this.scenarioConfig.part7Config;
	}
	constructor(private main: GeneralNeutralStateMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralNeutralStateMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		context._scenario.currentTaskMessage = 'Please Pre-Oxygenate the patient';
		context._scenario.uiWrapper.displayHUD({
			score: context._scenario.totalScore,
			maxScore: this._scenario.maxScore,
			onActionClicked: (actionType: HudActions) => {
				if(context.main.onHudActionClicked(actionType)) {
					return true;
				}
				switch(actionType) {
					case HudActions.PreOxygenatePatient:
						context.preOxygenate();
						return true;
					default:
						if(context.config.onSettingUpAnythingElse) {
							context.config.onSettingUpAnythingElse();
						}
						context._scenario.displayMessage(context._scenario.currentTaskMessage);
						return false;
				}
			}
		}, context._scenario.hudId);

		if(!context.main.config.isTestScenario && !context.main.config.isEmanuelMcKenzie) {
			context.scenario.toolbagId = context._scenario.uiWrapper.displayToolbag({
				onShouldShowOverlay: () => {
					return false;
				},
				onToolClicked: (data: DraggedSingleData) => {
					context._scenario.displayMessage(context.scenarioConfig.isTestScenario ? context.main.toolsMessageTestScenario : context._scenario.currentTaskMessage);
				}
			}, context._scenario.toolbagId);
		}
	}

	public preOxygenate() {
		const context = this;
		context.scenario.uiWrapper.displayPreOxygenateOptionsUI({
			onDoneClicked: (selection: number) => {
				if(!context.alreadyDone) {
					switch(selection) {
						case 2:
						case 3:
							context._scenario.preOxygenatePoints = 1000;
							break;
					}
					context._scenario.addScore(context._scenario.preOxygenatePoints);
					context.alreadyDone = true;
				}
				GeneralNeutralStatePart1.disableMenuItemCallbackPreOxygenate();

				var onDoneWithPopup = context._scenario.doSomething('Pre-oxygenating patient...');
				if(context.config.onPreOxygenated) { 
					context.config.onPreOxygenated(selection);
				}
				// context.scenario.debriefLog('Pre-Oxygenated Patient');
				context.main.loopVideo(this, context.config.waitForPreOxygenateVideoChapter());

				setTimeout(() => {
					context.updateSideMenu(selection);
					onDoneWithPopup();
					context._scenario.uiWrapper.displayNotificationUI({
						text: `<p class='notification-text'>Ok, We’re pre oxygenating the patient.</p>`,
						onDismissed: () => {
						}
					})
					context.onDone();
				}, constants.doSomethingTimeout);
			}
		})
	}

	public updateSideMenu(selection: number) {
		var apneaTime = 0;
		var stopSa02 = false;
		(window as any)['preoxy'] = 100;
		switch(selection) {
			case 0: //high nasal
			case 1: //nasal non invasive
				apneaTime = 480;
				(window as any)['reset-apnea-time'] = 480;
				break;

			case 2:  //non rebreather
			case 3: //bvm
				apneaTime = 300;
				(window as any)['reset-apnea-time'] = 300;
				break;
		}

		const context = this;
		context.scenario.sideMenuId = context.scenario.uiWrapper.displaySideMenu({
			updatedStuff: {
				apneaTimeInSeconds: apneaTime,
				sa02: 100,
			}
		}, context.scenario.sideMenuId);
	}
}